<template>
  <div>
    <vs-card>
      <div slot="header">
        <h3>
          Firma Electrónica Avanzada PAdES (PDF)  <span class="badge badge-primary badge-sm badage-title">Recomendado</span>
        </h3>
      </div>
      <div>
        <p class="font-z-1">Convierte el documento original en el estándar PAdES conforme a la especificación ISO-32000-1, agregando campos de firma de los firmantes. <a target="_blank" href="https://ayuda.verificamex.com/article/59-diferencia-entre-estrategia-de-firmado-pades-y-convencional">Más información.</a></p>

      </div>
      <div slot="footer">
        <vs-row vs-justify="flex-end">
          <vs-button @click="openSignPositionPopup" type="filled" color="primary">Seleccionar</vs-button>
        </vs-row>
      </div>
    </vs-card>
    <br>
    <vs-card>
      <div slot="header">
        <h3>
          Firma Electrónica Avanzada
        </h3>
      </div>
      <div>
        <p class="font-z-1"> Conserva el documento original y agrega una hoja de firmas al final del documento.  <a target="_blank" href="https://ayuda.verificamex.com/article/59-diferencia-entre-estrategia-de-firmado-pades-y-convencional/">Más información.</a></p>

      </div>
      <div slot="footer">
        <vs-row vs-justify="flex-end">
          <vs-button @click="submitNewDocument('CLASSIC')" type="filled" color="primary">Seleccionar</vs-button>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<script>
export default {
  name: "SignSelector",
  props: ['openSignPositionPopup', 'submitNewDocument']
}
</script>

<style scoped>

</style>
